import { ChoiceMenu } from 'components/eventView/filters/ChoiceMenu';
import { ActionButton } from 'elements/eventView/atomic/ActionButton';
import { ScrollHorizontal } from 'elements/functional/ScrollHorizontal';
import { EFonts } from 'libs/styles/styling';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext, useEffect } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
}

export const ProgramDayFilterRow = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { programDayFilter, setProgramDayFilter, setProgramCategoryIdsFilter, programDays } =
        ctxEventView;
    const analytics = useAnalytics();
    const { isWide } = ctxEventView;

    useEffect(() => {
        if (programDays.length > 1 && !programDayFilter) {
            setProgramDayFilter(programDays[0].dateKey);
        }
    }, [programDays]);

    function handleClick(dateKey: string, dayName: string) {
        analytics.track('event_ui.filter.clicked', {
            id: dateKey,
            title: dayName,
            type: 'date'
        });

        setProgramDayFilter(dateKey);
        setProgramCategoryIdsFilter(null);
    }

    if (ctxEventView.programSearchTerm) {
        return;
    }

    if (programDays.length <= 1) {
        return;
    }

    return (
        <S_ProgramDayFilterRow className={props.className} $isWide={isWide}>
            {isWide && (
                <>
                    <ChoiceMenu
                        selectedIndex={programDays.findIndex(
                            (day) => day.dateKey === programDayFilter
                        )}
                        items={[
                            ...programDays.map(
                                (day) =>
                                    day.day.toString() +
                                    '.' +
                                    (new Date(day.dateKey).getUTCMonth() + 1).toString() +
                                    '.'
                            )
                        ]}
                        onSelected={(index) => {
                            handleClick(programDays[index].dateKey, programDays[index].dayName);
                        }}
                    />
                </>
            )}
            {!isWide && (
                <S_ScrollHorizontal>
                    <S_Days>
                        {programDays.map((day) => {
                            const isHighlighted = programDayFilter === day.dateKey;
                            return (
                                <S_Day key={day.dateKey}>
                                    <S_DayText $isHighlighted={isHighlighted}>
                                        {day.dayName}
                                    </S_DayText>
                                    <S_ActionButton
                                        key={day.dateKey}
                                        //day and month
                                        text={
                                            day.day.toString() +
                                            '.' +
                                            (new Date(day.dateKey).getUTCMonth() + 1).toString() +
                                            '.'
                                        }
                                        highlighted={isHighlighted}
                                        onClick={() => {
                                            handleClick(day.dateKey, day.dayName);
                                        }}
                                    />
                                </S_Day>
                            );
                        })}
                    </S_Days>
                </S_ScrollHorizontal>
            )}
        </S_ProgramDayFilterRow>
    );
};

const S_ProgramDayFilterRow = styled.div<{ $isWide: boolean }>`
    background: #fff;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    padding: 10px 12px 10px 12px;
    ${(props) => {
        if (props.$isWide) {
            return css`
                box-shadow: none;
                height: unset;
                background: unset;
                margin: 0 0 50px 0;
            `;
        }
    }}
`;

const S_Days = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
    height: 100%;
`;

const S_Day = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
`;

const S_DayText = styled.div<{ $isHighlighted: boolean }>`
    color: ${(props) => (props.$isHighlighted ? '#3A3A3A' : '#929292')};
    font-family: ${EFonts.InterMedium};
    font-size: 12px;
    font-style: normal;
    line-height: normal;
    margin: 0px 0 3px 0;
`;

const S_ScrollHorizontal = styled(ScrollHorizontal)`
    ::-webkit-scrollbar {
        display: none;
    }
`;

const S_ActionButton = styled(ActionButton)`
    min-width: 40px;
`;
